<!-- <header-share class="main-scroll"></header-share> -->

<main id="main">
  <div class="wrap">
    <!-- <sticky-button></sticky-button> -->
    <div class="inner-wrap">
      <section class="main-video">
        <video muted
          autoplay
          loop
          width="100%"
          height="100%"
          poster="assets/imgs/service-m03.png">
          <source src="assets/video/bg_develop.mp4"
            type="video/mp4" />
        </video>
        <div class="main-text">
          <h2>Android / iOS 개발</h2>
          <p>우리에게 불가능한 개발이란 없습니다.</p>
        </div>
        <div class="scroll-icon">
          <p>SCROLL</p>
        </div>
      </section>

      <div class="visual-area">
        <section class="visual-wrap">
          <h2>
            누구나<span class="m-block"></span> 주목하는 앱 <br />
            최고의 개발자들이<span class="m-block"></span> 모였습니다.
          </h2>

          <p>
            우리는 당신이 생각하는 그 어떤 것이든 정확히 구현해 줄 수 있는
            준비가 되어 있습니다.
          </p>
        </section>
      </div>
      <!--스티키 영역-->

      <section class="main-text-area">
        <div class="scroll-wrap">
          <div class="stiky-wrap">
            <div class="title-area">
              <h2>불가능을 가능으로 만드는 우리의 기술력</h2>
              <p>
                우리는 단순한 시스템 부터 복잡한 시스템까지 명확하게 구현해 낼
                수 있는 우수한 기술력을 보유하고 있습니다.
              </p>
            </div>
            <!--타이틀 끝-->
            <div class="mockup-area">
              <div class="zero-box scroll-box">
                <div class="text-box"></div>
                <div class="phone-img-area">
                  <img src="assets/imgs/devel-phone.png"
                    alt="" />
                </div>
              </div>

              <div class="first-box scroll-box">
                <div class="text-box">
                  <h3>
                    <span>01</span>
                    짜릿한 반응 속도
                  </h3>

                  <p>
                    사용자에 클릭으로 모든 것이 즉각적으로<br />
                    반응하고, 펼쳐지도록 목표에 바로<br />
                    도달 할 수 있게 만들어주는 속도
                  </p>
                </div>
                <div class="phone-img-area">
                  <img src="assets/imgs/devel-phone.png"
                    alt=""
                    class="m-moc" />
                  <div class="inner-area">
                    <img src="assets/imgs/skills-img1.png"
                      alt="" />
                  </div>
                </div>
              </div>
              <div class="second-box scroll-box">
                <div class="phone-img-area">
                  <img src="assets/imgs/devel-phone.png"
                    alt=""
                    class="m-moc" />
                  <div class="inner-area">
                    <img src="assets/imgs/skills-img2.png"
                      alt=""
                      class="img2" />
                  </div>
                </div>
                <div class="text-box">
                  <h3>
                    <span>02</span>
                    차별적이고,<br />
                    자연스러운 효과
                  </h3>

                  <p>
                    서비스에 맞춘 다양한 인터랙션을 통해<br />
                    디자인에 생동감을 입히고,<br />
                    자연스러운 반응 효과까지
                  </p>
                </div>
              </div>
              <div class="third-box scroll-box">
                <div class="text-box">
                  <h3>
                    <span>03</span>
                    복잡한 시스템도<br />
                    손쉽게 해결
                  </h3>

                  <p>
                    단순한 시스템 부터 복잡한 시스템까지<br />
                    모든 경우의 수를 파악 하여 기능을<br />
                    입히는 능력 우리는 손쉽게 구현을 합니다.
                  </p>
                </div>
                <div class="phone-img-area">
                  <img src="assets/imgs/devel-phone.png"
                    alt=""
                    class="m-moc" />
                  <div class="inner-area">
                    <img src="assets/imgs/skills-img3.png"
                      alt=""
                      class="img3" />
                  </div>
                </div>

                <div class="code-area">
                  <div class="illustration-editor">
                    <div class="code-blocks">
                      <div class="code code-html">
                        <header>
                          <svg width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Artboard-Copy-2"
                              transform="translate(-1210.000000, -240.000000)">
                              <rect id="Rectangle"
                                fill="#1D1E22"
                                x="1200"
                                y="230"
                                width="350"
                                height="296"
                                rx="8"></rect>
                              <path
                                d="M1223.97677,240.612816 C1224.02935,240.703952 1224.06978,240.801571 1224.09705,240.903192 L1224.58229,242.711842 C1224.80561,243.544221 1225.45578,244.19439 1226.28816,244.41771 L1228.09681,244.902953 C1228.74059,245.075675 1229.12246,245.737582 1228.94974,246.381366 C1228.92248,246.482987 1228.88204,246.580606 1228.82946,246.671742 L1227.89367,248.29377 C1227.463,249.040261 1227.463,249.959739 1227.89367,250.70623 L1228.82946,252.328258 C1229.16256,252.905614 1228.96454,253.643678 1228.38718,253.976769 C1228.29605,254.029347 1228.19843,254.069783 1228.09681,254.097047 L1226.28816,254.58229 C1225.45578,254.80561 1224.80561,255.455779 1224.58229,256.288158 L1224.09705,258.096808 C1223.92433,258.740591 1223.26242,259.122463 1222.61863,258.949742 C1222.51701,258.922478 1222.41939,258.882042 1222.32826,258.829464 L1220.70623,257.893675 C1219.95974,257.463005 1219.04026,257.463005 1218.29377,257.893675 L1216.67174,258.829464 C1216.09439,259.162555 1215.35632,258.96454 1215.02323,258.387184 C1214.97065,258.296048 1214.93022,258.198429 1214.90295,258.096808 L1214.41771,256.288158 C1214.19439,255.455779 1213.54422,254.80561 1212.71184,254.58229 L1210.90319,254.097047 C1210.25941,253.924325 1209.87754,253.262418 1210.05026,252.618634 C1210.07752,252.517013 1210.11796,252.419394 1210.17054,252.328258 L1211.10633,250.70623 C1211.537,249.959739 1211.537,249.040261 1211.10633,248.29377 L1210.17054,246.671742 C1209.83744,246.094386 1210.03546,245.356322 1210.61282,245.023231 C1210.70395,244.970653 1210.80157,244.930217 1210.90319,244.902953 L1212.71184,244.41771 C1213.54422,244.19439 1214.19439,243.544221 1214.41771,242.711842 L1214.90295,240.903192 C1215.07567,240.259409 1215.73758,239.877537 1216.38137,240.050258 C1216.48299,240.077522 1216.58061,240.117958 1216.67174,240.170536 L1218.29377,241.106325 C1219.04026,241.536995 1219.95974,241.536995 1220.70623,241.106325 L1222.32826,240.170536 C1222.90561,239.837445 1223.64368,240.03546 1223.97677,240.612816 Z M1219.5,245.850556 C1217.48447,245.850556 1215.85056,247.484468 1215.85056,249.5 C1215.85056,251.515532 1217.48447,253.149444 1219.5,253.149444 C1221.51553,253.149444 1223.14944,251.515532 1223.14944,249.5 C1223.14944,247.484468 1221.51553,245.850556 1219.5,245.850556 Z"
                                id="Combined-Shape"
                                fill="#4C4F5A"></path>
                            </g>
                          </svg>
                          <h4>HTML</h4>
                          <svg width="20px"
                            height="11px"
                            viewBox="0 0 20 11"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd">
                              <g id="Artboard-Copy-2"
                                transform="translate(-1518.000000, -244.000000)">
                                <rect id="Rectangle"
                                  fill="#1D1E22"
                                  x="1200"
                                  y="230"
                                  width="350"
                                  height="296"
                                  rx="8"></rect>
                                <polyline id="Path-3"
                                  stroke="#4C4F5A"
                                  stroke-width="2.4137931"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  points="1520 246 1527.90503 253 1536 246"></polyline>
                              </g>
                            </g>
                          </svg>
                        </header>
                        <div class="code-content">
                          <code>
                            <p>
                              <span class="c-t">&lt;</span><span class="c-h">p</span>&nbsp;
                              <span class="c-a">[ngClass]</span>=<span class="c-v">"checkChatType(chat, 'chat')"</span>
                              <span class="c-t">&gt;</span>
                            </p>
                            <div class="indent-area">
                              <p>
                                <span class="c-t">&lt;</span><span class="c-h">img</span>&nbsp;
                                <span class="c-a">src</span>=<span class="c-v">"assets/imgs/add- file.png"</span>
                                <span class="c-a">&nbsp;class</span>=<span class="c-v">"add-file"</span><span
                                  class="c-t">/></span>
                              </p>
                              <p><span>{{</span>chat.filename<span>}}</span></p>
                              <p>
                                <span class="c-t">&lt;</span><span class="c-h">span</span>&nbsp;
                                <span class="c-a">*ngIf</span>=<span class="c-v">"chat.contentType ==
                                  'text'"</span><span class="c-t">&gt;</span>
                              </p>
                              <p><span>{{</span>chat.content<span>}}</span></p>
                              <p>
                                <span class="c-t">&lt;/</span><span class="c-h">span</span>
                                <span class="c-t">&gt;</span>
                              </p>
                            </div>
                            <p>
                              <span class="c-t">&lt;/</span>
                              <span class="c-h">p</span>
                              <span class="c-t">&gt;</span>
                            </p>
                          </code>
                        </div>
                      </div>
                      <div class="code code-css">
                        <header>
                          <svg width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Artboard-Copy-2"
                              transform="translate(-1210.000000, -240.000000)">
                              <rect id="Rectangle"
                                fill="#1D1E22"
                                x="1200"
                                y="230"
                                width="350"
                                height="296"
                                rx="8"></rect>
                              <path
                                d="M1223.97677,240.612816 C1224.02935,240.703952 1224.06978,240.801571 1224.09705,240.903192 L1224.58229,242.711842 C1224.80561,243.544221 1225.45578,244.19439 1226.28816,244.41771 L1228.09681,244.902953 C1228.74059,245.075675 1229.12246,245.737582 1228.94974,246.381366 C1228.92248,246.482987 1228.88204,246.580606 1228.82946,246.671742 L1227.89367,248.29377 C1227.463,249.040261 1227.463,249.959739 1227.89367,250.70623 L1228.82946,252.328258 C1229.16256,252.905614 1228.96454,253.643678 1228.38718,253.976769 C1228.29605,254.029347 1228.19843,254.069783 1228.09681,254.097047 L1226.28816,254.58229 C1225.45578,254.80561 1224.80561,255.455779 1224.58229,256.288158 L1224.09705,258.096808 C1223.92433,258.740591 1223.26242,259.122463 1222.61863,258.949742 C1222.51701,258.922478 1222.41939,258.882042 1222.32826,258.829464 L1220.70623,257.893675 C1219.95974,257.463005 1219.04026,257.463005 1218.29377,257.893675 L1216.67174,258.829464 C1216.09439,259.162555 1215.35632,258.96454 1215.02323,258.387184 C1214.97065,258.296048 1214.93022,258.198429 1214.90295,258.096808 L1214.41771,256.288158 C1214.19439,255.455779 1213.54422,254.80561 1212.71184,254.58229 L1210.90319,254.097047 C1210.25941,253.924325 1209.87754,253.262418 1210.05026,252.618634 C1210.07752,252.517013 1210.11796,252.419394 1210.17054,252.328258 L1211.10633,250.70623 C1211.537,249.959739 1211.537,249.040261 1211.10633,248.29377 L1210.17054,246.671742 C1209.83744,246.094386 1210.03546,245.356322 1210.61282,245.023231 C1210.70395,244.970653 1210.80157,244.930217 1210.90319,244.902953 L1212.71184,244.41771 C1213.54422,244.19439 1214.19439,243.544221 1214.41771,242.711842 L1214.90295,240.903192 C1215.07567,240.259409 1215.73758,239.877537 1216.38137,240.050258 C1216.48299,240.077522 1216.58061,240.117958 1216.67174,240.170536 L1218.29377,241.106325 C1219.04026,241.536995 1219.95974,241.536995 1220.70623,241.106325 L1222.32826,240.170536 C1222.90561,239.837445 1223.64368,240.03546 1223.97677,240.612816 Z M1219.5,245.850556 C1217.48447,245.850556 1215.85056,247.484468 1215.85056,249.5 C1215.85056,251.515532 1217.48447,253.149444 1219.5,253.149444 C1221.51553,253.149444 1223.14944,251.515532 1223.14944,249.5 C1223.14944,247.484468 1221.51553,245.850556 1219.5,245.850556 Z"
                                id="Combined-Shape"
                                fill="#4C4F5A"></path>
                            </g>
                          </svg>
                          <h4>CSS</h4>
                          <svg width="20px"
                            height="11px"
                            viewBox="0 0 20 11"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd">
                              <g id="Artboard-Copy-2"
                                transform="translate(-1518.000000, -244.000000)">
                                <rect id="Rectangle"
                                  fill="#1D1E22"
                                  x="1200"
                                  y="230"
                                  width="350"
                                  height="296"
                                  rx="8"></rect>
                                <polyline id="Path-3"
                                  stroke="#4C4F5A"
                                  stroke-width="2.4137931"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  points="1520 246 1527.90503 253 1536 246"></polyline>
                              </g>
                            </g>
                          </svg>
                        </header>
                        <div class="code-content">
                          <code>
                            <p class="line-1">
                              <span class="c-c">p</span>&nbsp;<span>&#123;</span>
                              <span class="c-a">padding</span>:
                              <span class="c-g">0.625rem</span>;<span class="c-a">font-size</span>:
                            </p>
                            <br />
                            <div class="indent-area">
                              <p class="line-2">
                                <span class="c-g">1rem</span>;<span class="c-a">color</span>: <span
                                  class="c-v">#000</span>;<span class="c-a">border-radius</span>:
                              </p>
                              <br />
                              <p class="line-3">
                                <span class="c-g">10px 0 10px 10px</span>;<span class="c-a">white-space</span>:
                              </p>
                              <br />
                              <p class="line-4">
                                <span class="c-v">pre-line</span>;
                              </p>
                              <br />
                              <p class="line-5">
                                <span class="c-c">span</span> &#123;<span class="c-a">display</span>: <span
                                  class="c-v">flex</span>;&#125;
                              </p>
                            </div>
                            <p class="line-6">&#125;</p>
                          </code>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="fourth-box scroll-box">
                <div class="code-area">
                  <div class="illustration-editor">
                    <div class="code-blocks">
                      <div class="code code-js">
                        <header>
                          <svg width="19px"
                            height="19px"
                            viewBox="0 0 19 19"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="Artboard-Copy-2"
                              transform="translate(-1210.000000, -240.000000)">
                              <rect id="Rectangle"
                                fill="#1D1E22"
                                x="1200"
                                y="230"
                                width="350"
                                height="296"
                                rx="8"></rect>
                              <path
                                d="M1223.97677,240.612816 C1224.02935,240.703952 1224.06978,240.801571 1224.09705,240.903192 L1224.58229,242.711842 C1224.80561,243.544221 1225.45578,244.19439 1226.28816,244.41771 L1228.09681,244.902953 C1228.74059,245.075675 1229.12246,245.737582 1228.94974,246.381366 C1228.92248,246.482987 1228.88204,246.580606 1228.82946,246.671742 L1227.89367,248.29377 C1227.463,249.040261 1227.463,249.959739 1227.89367,250.70623 L1228.82946,252.328258 C1229.16256,252.905614 1228.96454,253.643678 1228.38718,253.976769 C1228.29605,254.029347 1228.19843,254.069783 1228.09681,254.097047 L1226.28816,254.58229 C1225.45578,254.80561 1224.80561,255.455779 1224.58229,256.288158 L1224.09705,258.096808 C1223.92433,258.740591 1223.26242,259.122463 1222.61863,258.949742 C1222.51701,258.922478 1222.41939,258.882042 1222.32826,258.829464 L1220.70623,257.893675 C1219.95974,257.463005 1219.04026,257.463005 1218.29377,257.893675 L1216.67174,258.829464 C1216.09439,259.162555 1215.35632,258.96454 1215.02323,258.387184 C1214.97065,258.296048 1214.93022,258.198429 1214.90295,258.096808 L1214.41771,256.288158 C1214.19439,255.455779 1213.54422,254.80561 1212.71184,254.58229 L1210.90319,254.097047 C1210.25941,253.924325 1209.87754,253.262418 1210.05026,252.618634 C1210.07752,252.517013 1210.11796,252.419394 1210.17054,252.328258 L1211.10633,250.70623 C1211.537,249.959739 1211.537,249.040261 1211.10633,248.29377 L1210.17054,246.671742 C1209.83744,246.094386 1210.03546,245.356322 1210.61282,245.023231 C1210.70395,244.970653 1210.80157,244.930217 1210.90319,244.902953 L1212.71184,244.41771 C1213.54422,244.19439 1214.19439,243.544221 1214.41771,242.711842 L1214.90295,240.903192 C1215.07567,240.259409 1215.73758,239.877537 1216.38137,240.050258 C1216.48299,240.077522 1216.58061,240.117958 1216.67174,240.170536 L1218.29377,241.106325 C1219.04026,241.536995 1219.95974,241.536995 1220.70623,241.106325 L1222.32826,240.170536 C1222.90561,239.837445 1223.64368,240.03546 1223.97677,240.612816 Z M1219.5,245.850556 C1217.48447,245.850556 1215.85056,247.484468 1215.85056,249.5 C1215.85056,251.515532 1217.48447,253.149444 1219.5,253.149444 C1221.51553,253.149444 1223.14944,251.515532 1223.14944,249.5 C1223.14944,247.484468 1221.51553,245.850556 1219.5,245.850556 Z"
                                id="Combined-Shape"
                                fill="#4C4F5A"></path>
                            </g>
                          </svg>
                          <h4>JS</h4>
                          <svg width="20px"
                            height="11px"
                            viewBox="0 0 20 11"
                            version="1.1"
                            xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g stroke="none"
                              stroke-width="1"
                              fill="none"
                              fill-rule="evenodd">
                              <g id="Artboard-Copy-2"
                                transform="translate(-1518.000000, -244.000000)">
                                <rect id="Rectangle"
                                  fill="#1D1E22"
                                  x="1200"
                                  y="230"
                                  width="350"
                                  height="296"
                                  rx="8"></rect>
                                <polyline id="Path-3"
                                  stroke="#4C4F5A"
                                  stroke-width="2.4137931"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  points="1520 246 1527.90503 253 1536 246"></polyline>
                              </g>
                            </g>
                          </svg>
                        </header>
                        <div class="code-content">
                          <code>
                            <p class="line-js-1">
                              <span class="c-f">toggleDetail</span>(<span class="c-a">group</span>) &#123;
                            </p>
                            <br />
                            <p class="line-js-2">
                              <span class="c-l">if</span> (<span class="c-h">this</span>.<span
                                class="c-f">isDetailShown</span>(<span class="c-a">group</span>))
                            </p>
                            <br />
                            <p class="line-js-3">&#123;</p>
                            <br />
                            <p class="line-js-4">
                              <span class="c-h">this</span>.<span class="c-a">shownDetail</span>
                              = <span class="c-h">null</span>;
                            </p>
                            <br />
                            <p class="line-js-5">
                              &#125; <span class="c-l">else</span> &#123;
                            </p>
                            <br />
                            <p class="line-js-6">
                              <span class="c-h">this</span>.<span class="c-a">shownDetail</span>
                              = <span class="c-a">group</span>;
                            </p>
                            <br />
                            <p class="line-js-7">&#125;</p>
                            <br />
                            <p class="line-js-8">&#125;</p>
                            <br />
                            <p class="line-js-9">
                              <span class="c-f">isDetailShown</span>(<span class="c-a">group</span>) &#123;
                            </p>
                            <br />
                            <p class="line-js-10">
                              <span class="c-l">return</span>&nbsp;
                              <span class="c-h">this</span>.<span class="c-a">shownDetail</span>
                              ===
                            </p>
                            <br />
                            <p class="line-js-11">
                              <span class="c-a">group</span>;
                            </p>
                            <br />
                            <p class="line-js-12">&#125;</p>
                            <br />
                          </code>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="phone-img-area">
                  <img src="assets/imgs/devel-phone.png"
                    alt=""
                    class="m-moc" />
                  <div class="inner-area">
                    <img src="assets/imgs/skills-img4.png"
                      alt=""
                      class="img4" />
                  </div>
                </div>
                <div class="text-box">
                  <h3>
                    <span>04</span>
                    사용자 중심의 개발
                  </h3>

                  <p>
                    기능이 잘 되는 것은 기본<br />
                    사용자가 편하게 사용하기 위한 서비스를<br />
                    목표로 기능을 만들어 나갑니다.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <!-- </div> -->
        </div>
      </section>

      <section class="field-box">
        <div class="title-area">
          <h2>최상의 결과를 부르는 우리의 전문 분야</h2>
          <p>
            우리의 개발팀은 최고의 기술력으로 클라이언트의 상황에 맞는 최상의
            결과를 제공합니다.
          </p>
        </div>
        <div class="field-area">
          <article>
            <h3>서비스 플랫폼</h3>
            <p>
              모바일 서비스 환경 구축,<br />
              플랫폼을 하나의 패키지로 제공
            </p>
          </article>
          <article>
            <h3>시스템 개발</h3>
            <p>
              모바일 트렌드 분석을 통한<br />
              시스템 전략 제시 및 인터페이스 개발
            </p>
          </article>
          <article>
            <h3>콘텐츠 제작</h3>
            <p>
              아이디어 구현 / 게임 제작 / 영상 제작<br />
              / 홍보용 웹 사이트 제작
            </p>
          </article>
          <article>
            <h3>결제 모듈 연동</h3>
            <p>
              KG이니시스 / 인앱 결제 등<br />
              간편 결제 시스템 구현
            </p>
          </article>
          <article>
            <h3>증강 가상 현실</h3>
            <p>
              컴퓨터 비전 솔루션을 활용한 유니티<br />
              / 언리얼 / ARkit / 이미지 인식<br />
              / GPS 기반 증강 현실 플랫폼 구현
            </p>
          </article>
          <article>
            <h3>인공지능 AI</h3>
            <p>
              챗봇 / 얼굴인식 / 데이터 분류 / 사물 인식 등<br />
              데이터 학습을 통한 인공지능 솔루션 제공
            </p>
          </article>
        </div>
      </section>

      <section class="scroll-section2">
        <div class="sec2-title">
          <h2>플랫폼에 최적화된 개발 스펙</h2>
          <p>
            우리는 새로운 개발 환경에도 두려워 하지 않으며, 최상의 결과물을
            만들어 냅니다.
          </p>
        </div>
        <div class="table-area">
          <table>
            <thead>
              <tr>
                <th>Frount-End</th>
                <th>Back-End</th>
                <th>DB</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Ionic</td>
                <td>Firebase</td>
                <td>Firebase</td>
              </tr>
              <tr>
                <td>Angular</td>
                <td>Node.js</td>
                <td>MariaDB</td>
              </tr>
              <tr>
                <td>HTML</td>
                <td>PHP</td>
                <td>MySQL</td>
              </tr>
              <tr>
                <td>CSS</td>
                <td>Java</td>
                <td>SQLite</td>
              </tr>
              <tr>
                <td>Javascript</td>
                <td>Python</td>
                <td>redis</td>
              </tr>
              <tr>
                <td>swift</td>
                <td>C++</td>
                <td></td>
              </tr>
              <tr>
                <td>Java</td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="back-img-wrap">
          <img src="assets/imgs/dev-back-1.png"
            class="move-back-img1"
            alt="" />
          <img src="assets/imgs/dev-back-2.png"
            class="move-back-img2"
            alt="" />
          <img src="assets/imgs/dev-back-3.png"
            class="move-back-img3"
            alt="" />
          <img src="assets/imgs/dev-back-4.png"
            class="move-back-img4"
            alt="" />
        </div>
      </section>

      <section class="desc-area">
        <h2>
          모든 기기<br />
          동일한 경험 제공
        </h2>

        <p>
          당신이 만든 서비스는 모든 디바이스에서 <br />
          하나로 연결 되어 동일한 경험을 제공해 줄 것 입니다.
        </p>
      </section>

      <section class="quality-area">
        <div class="title-area">
          <h2>
            완성도를 높이고,<span class="text-break"></span> 높은 품질을
            보장합니다.
          </h2>
          <p>
            우리는 서비스의 더 나아갈 수 있는 방향을 찾아
            <span class="text-bold">끊임없이 체크 하며 보완</span>해 나가며,
            한층 더 <span class="text-bold">완성도 있는 서비스</span>를 만들어
            나갑니다.
          </p>
        </div>
        <div class="quality-box-wrap">
          <ol>
            <li>
              <span>01</span>
              <p class="li-title">개발 완료</p>
              <p>
                기술적 요구사항에 맞는 기술을 구현하여 앱 환경을 구축합니다.
              </p>
            </li>
            <li>
              <span>02</span>
              <p class="li-title">QA테스트</p>
              <p>
                실사용자 입장에서 여러 기기를 통한 테스트를 통해 끊임없이
                체크하며 보완을 해나갑니다.
              </p>
            </li>
            <li>
              <span>03</span>
              <p class="li-title">앱 배포</p>
              <p>
                테스트를 거쳐 검증된 앱을 쉽고 빠르게 앱 스토어에 등록하는
                절차를 거칩니다.
              </p>
            </li>
            <li>
              <span>04</span>
              <p class="li-title">유지 보수</p>
              <p>
                확장성과 가독성을 고려한 간결한 코드들로 차후 유지보수와 기능
                확장을 만들어 갑니다.
              </p>
            </li>
          </ol>
        </div>
      </section>
      <section class="bottom-line">
        <div class="bottom_box">
          <h2>케이엔큐레이션</h2>
          <p>우리는 가장 정확하고, 제대로 된 개발을 합니다.</p>
        </div>
      </section>
    </div>
    <footer-share id="mainFooter"> </footer-share>
  </div>
</main>

<img src="assets/imgs/develop_01.gif"
  alt=""
  class="loading" />
<img src="assets/imgs/develop_02.gif"
  alt=""
  class="loading" />
<img src="assets/imgs/develop_03.gif"
  alt=""
  class="loading" />
<img src="assets/imgs/develop_04.gif"
  alt=""
  class="loading" />
